import {
  BuildingOffice2Icon,
  BuildingOfficeIcon,
  HomeModernIcon,
  MapIcon,
} from "@heroicons/react/24/outline";

type SearchModeCopy = {
  newOffers: string;
  updatedOffers: string;
  allOffers: string;
  fallback: string;
};

type EstateTypeCopy = {
  houses: string;
  flats: string;
  land: string;
};

export function getSearchModeLabel(sendOfferAs: string, copy: SearchModeCopy) {
  return (
    {
      NEW: copy.newOffers,
      UPDATED: copy.updatedOffers,
      ALL: copy.allOffers,
    }[sendOfferAs] ?? copy.fallback
  );
}

export function getWatchDogIcon(estateType: string) {
  if (estateType === "Domy") {
    return HomeModernIcon;
  }

  if (estateType === "Byty") {
    return BuildingOfficeIcon;
  }

  if (estateType === "Pozemky") {
    return MapIcon;
  }

  return BuildingOffice2Icon;
}
export function getEstateTypeSingular(
  estateType: string,
  copy: EstateTypeCopy,
): string {
  return (
    {
      Domy: copy.houses,
      Byty: copy.flats,
      Pozemky: copy.land,
    }[estateType] ?? estateType
  );
}
